var $ = require('./jquery');
var Handlebars = require('handlebars');
var textMask = require('vanilla-text-mask');

var $form = $('#form');
var $fields = $('#fields');
var $email = $('input[type="email"]');
var $notes = $('#notes');
var $submit = $('button[type="submit"]');

var fieldTemplate = Handlebars.compile($('#fieldTemplate').html());
var checkboxTemplate = Handlebars.compile($('#checkboxTemplate').html());

var activeEamil = '';
var waitingForRequest = false;
var activeSubmitText = '';

function fieldsReceived(data, status, request) {
  $fields.empty();
  var $field, $input, type;

  for (var i = 0; i < data.fields.length; i++) {
    if ( 'checkbox' === data.fields[i].type ) {
      $field = $(checkboxTemplate(data.fields[i])).appendTo($fields);

    } else if ( 'submit' === data.fields[i].type ) {
      $field = null;
      activeSubmitText = data.fields[i].label;
      $submit.val(activeSubmitText).text(activeSubmitText);
    } else {
      var fields = data.fields[i];
      if ( window.hasOwnProperty('exports') && window.exports[fields.name] ) {
        fields.value = window.exports[fields.name];
      }

      $field = $(fieldTemplate(fields)).appendTo($fields);
      $input = $field.find('input');

      $input.validateValue({
        $error: $input.siblings('.error')
      });

      if ( $input[0].type === 'tel' ) {
        textMask.maskInput({
          inputElement: $input[0],
          mask: ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]
        });
      }
    }
  }

  $submit.prop('disabled', false);
  $fields.find('input:eq(0)').focus();

  if ( data.msg ) {
    $notes.html('<h1 class="notes">' + data.msg + '</h1>');
  }

  waitingForRequest = false;
}

function loginReceived(data, status, request) {
  waitingForRequest = false;

  if ( data.status ) {
    window.location.replace(data.redirect);
  } else {
    var msg, $element;

    msg = '<h1 class="notes">' + data.msg + '</h1>';

    for (var field in data.fields) {
      $element = $fields.find('[name="' + field + '"]');
      if ( $element.length ) {
        $element.siblings('.error').text(data.fields[field]);
      } else {
        msg += '<p>' + data.fields[field] + '</p>';
      }
    }

    $submit.prop('disabled', false);
    $submit.text(activeSubmitText);

    $notes.html(msg);
  }
}

function getFieldData() {
  var values = {
    nonce: apiSettings.nonce,
    email: $email.val()
  };

  $form.find('input').each(function(index, element) {
    if ( 'checkbox' === element.type ) {
      values[element.name] = element.checked ? 1 : 0;
    } else {
      values[element.name] = element.value;
    }
  });

  return values;
}

function error(request, status, error) {
  $notes.text('Uh oh! There was a problem processing your request. Please refresh your browser and try again. If the problem persists please contact us!');
  console.error('Request', error);
  console.error('Status', status);
  console.error('Error', error);
  waitingForRequest = false;
}

$email.on('blur', function(event) {
  var data = getFieldData();

  if ( activeEamil !== data.email ) {
    $.tyndaleAjax({
      url: '/account/form',
      dataType: 'json',
      success: fieldsReceived,
      error: error,
      data: getFieldData()
    });

    activeEamil = data.email;
    waitingForRequest = true;

    $submit.text('Please Wait...');
    $submit.prop('disabled', true);
  }
});

$form.on('submit', function(event) {
  if ( waitingForRequest ) return false;
  var data = getFieldData();

  if ( data.email === activeEamil ) {
    $.tyndaleAjax({
      url: '/account/login',
      method: 'POST',
      dataType: 'json',
      success: loginReceived,
      error: error,
      data: data
    });

  } else {
    $.tyndaleAjax({
      url: '/account/form',
      dataType: 'json',
      success: fieldsReceived,
      error: error,
      data: data
    });

    activeEamil = data.email;
  }

  $submit.text('Please Wait...');
  $submit.prop('disabled', true);

  waitingForRequest = true;
  return false;
});



//////////////////
// WEBPACK FOOTER
// ./views/js/login.js
// module id = 18
// module chunks = 3